module.exports = __webpack_public_path__ + "img/chart-icon.0dae438f.svg";